var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attendances d-flex align-items-stretch h-100"},[_c('div',{staticClass:"col p-0 d-flex",attrs:{"id":"page-content-wrapper"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}],staticClass:"loader disable"}),_vm._v(" "),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }